<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>设置管理->设置心跳参数设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
         
        <!--考勤配置 -->
        <div class="container" style="width:95%;">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                
                <el-form-item   prop="deptId" label="学校切换">
                    <el-select v-model="form.deptId" placeholder="请选择学校" 
                                @change="onDeptChange">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> 
                
                <el-form-item prop="deviceId" label="白名单设备">
                     <el-select v-model="form.deviceId" clearable multiple placeholder="请选择">
                            <el-option
                                v-for="item in devices"
                                :key="item.deviceNo"
                                :label="item.deviceNo"
                                :value="item.deviceNo">
                                <span style="float: right;font-size: 13px">{{ item.deviceNo }}-{{ item.address }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </el-option>
                        </el-select>
                </el-form-item>

                <el-form-item prop="heartbeatCycle" label="心跳周期">
                     <el-input v-model="form.heartbeatCycle" maxlength="10"  style="width:180px;" type="number"></el-input>(秒)
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer" style="text-align:right">
                <el-button type="danger" @click="clear()">清空配置</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
        </div>
        <div style="font-size:12px;color:#BBBBBB;padding:5px;line-height:22px;margin-bottom:10px;">
            设置心跳参数设置功能说明如下：<br/>
            1、白名单设备属性说明：在白名单内的设备需要实时上报数据。<br/>
            2、心跳周期属性说明：为了避免高频度的上报给平台形成的压力，对于犯罪嫌疑人、重点关注人员、VIP访客、陌生人为实时上报。
            其他的上报周期通过心跳周期频率上报。
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import { MessageBox } from 'element-ui';

    export default {
        name:"AttendanceConfig",
        data(){
            return{
                form:{
                    deptId:"",
                    deviceId:"",
                    heartbeatCycle:""
                },
                depts:[],
                devices:[],
                rules: {
                    heartbeatCycle: [
                        { required: true, message: '请输入心跳周期', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
            this.getDeptData();
        },
        components: {
        },
        methods:{
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getDevices();
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 切换学校
            onDeptChange(){
                this.getDevices();
                this.getData();
            },
            // 获取设备
            getDevices(){
                let url  = this.listDeviceSelectUrl;
                let data = {
                    commonSign:1,
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.devices = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.listSetParamUrl;
                let data = {
                    deptId:this.form.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res));
                    if(res.status==200){
                        // 白名单设备绑定
                        this.form.deviceId=(res.data.deviceId_key == null?"":res.data.deviceId_key.split(","));
                        // 心跳周期
                        this.form.heartbeatCycle=res.data.heartbeatCycle_key;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        
                        let configKeyArr=new Array();
                        let configValArr=new Array();
                        
                        // 白名单设备绑定
                        configKeyArr.push('deviceId_key');
                        configValArr.push(this.form.deviceId);

                        // 心跳周期
                        configKeyArr.push('heartbeatCycle_key');
                        configValArr.push(this.form.heartbeatCycle);


                        let url = this.setParamAddUrl;
                        let data = {
                            deptId:this.form.deptId,
                            paramKey:configKeyArr.join(";"),
                            paramValue:configValArr.join(";")
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            this.$commonFn.showTip(err,3);
                        });

                    }
                });
            },
            // 清空配置
            clear(){
                 MessageBox.confirm('此操作将永久清空配置数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((resolve) => {
                    let url = this.setParamDelUrl;
                    let data = {
                        deptId:this.form.deptId
                    };
                    this.apiPost(url, data).then((res) => {
                        if(res.status === 200){
                            this.$commonFn.showTip(res.message,1);
                            this.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }, (err) => {
                        this.$commonFn.showTip(err,3);
                    });
                }).catch(() => {
                });
                
            },
            filterCascader(data){
                // 获取任意选项最后值
                let arrVal = new Array();
                for(var i=0; i<data.length;i++){
                    arrVal.push(data[i][data[i].length-1]);
                }
               return arrVal.join();
            },
            getName(setVal,data){
                // 角色、部门递归获取层级名称
                if(this.$util.isNotEmpty(data)){
                   let valArr = setVal.split(",");
                   var arr = new Array();
                   for(var i = 0;i < valArr.length;i++){
                       var tempArr = new Array();
                       this.recursionCascader(valArr[i], data, tempArr, data);
                       arr.push(tempArr.reverse());
                   }
                   // console.log("获取值"+JSON.stringify(arr))
                   return arr;
                }
            },
            recursionCascader(val, cdata, tempArr, data){
                if(val == 0){
                    return;
                }
                // 递归获取值
                for(var i=0; i<cdata.length;i++){
                   if(cdata[i].value == val){
                       tempArr.push(val);
                       this.recursionCascader(cdata[i].parentId, data, tempArr, data);
                   }
                   if(cdata[i].children && cdata[i].children.length) {
                       this.recursionCascader(val, cdata[i].children, tempArr, data);
                   }
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/setparam/Setparam.vue